// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".music_list_wrapper[data-v-c801c57a]{position:relative;padding:.24rem .12rem;background:#fff}", ""]);
// Exports
module.exports = exports;
